"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
function unionize(record, config) {
  var _a = config || {},
    _b = _a.value,
    valProp = _b === void 0 ? undefined : _b,
    _c = _a.tag,
    tagProp = _c === void 0 ? 'tag' : _c;
  var creators = {};
  var _loop_1 = function _loop_1(tag) {
    creators[tag] = function (value) {
      var _a, _b;
      if (value === void 0) {
        value = {};
      }
      return valProp ? (_a = {}, _a[tagProp] = tag, _a[valProp] = value, _a) : __assign({}, value, (_b = {}, _b[tagProp] = tag, _b));
    };
  };
  for (var tag in record) {
    _loop_1(tag);
  }
  var is = {};
  var _loop_2 = function _loop_2(tag) {
    is[tag] = function (variant) {
      return variant[tagProp] === tag;
    };
  };
  for (var tag in record) {
    _loop_2(tag);
  }
  function evalMatch(variant, cases, defaultCase) {
    if (defaultCase === void 0) {
      defaultCase = cases["default"];
    }
    var handler = cases[variant[tagProp]];
    return handler ? handler(valProp ? variant[valProp] : variant) : defaultCase(variant);
  }
  var match = function match(first, second) {
    return second ? evalMatch(first, second) : function (variant) {
      return evalMatch(variant, first);
    };
  };
  var identity = function identity(x) {
    return x;
  };
  var transform = function transform(first, second) {
    return second ? evalMatch(first, second, identity) : function (variant) {
      return evalMatch(variant, first, identity);
    };
  };
  var as = {};
  var _loop_3 = function _loop_3(expectedTag) {
    var _a;
    as[expectedTag] = match((_a = {}, _a[expectedTag] = function (x) {
      return x;
    }, _a["default"] = function (val) {
      throw new Error("Attempted to cast " + val[tagProp] + " as " + expectedTag);
    }, _a));
  };
  for (var expectedTag in record) {
    _loop_3(expectedTag);
  }
  return Object.assign({
    is: is,
    as: as,
    match: match,
    transform: transform,
    _Record: record
  }, creators);
}
exports.unionize = unionize;
/**
 * Creates a pseudo-witness of a given type. That is, it pretends to return a value of
 * type `T` for any `T`, but it's really just returning `undefined`. This white lie
 * allows convenient expression of the value types in the record you pass to `unionize`.
 */
exports.ofType = function () {
  return undefined;
};
exports["default"] = unionize;
//# sourceMappingURL=index.js.map
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/unionize/lib/index.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/unionize/lib/index.js");
  }
}();